// extracted by mini-css-extract-plugin
export default {"container":"style_container__NU6ih","innerContainer":"style_innerContainer__TpP8T"};